var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ABEAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9062 21.4438C20.4251 21.0354 19.6999 21.0354 19.2188 21.4438C18.7376 21.8521 18.0124 21.8521 17.5312 21.4438C17.0501 21.0354 16.3249 21.0354 15.8438 21.4438C15.3626 21.8521 14.6374 21.8521 14.1562 21.4438C13.6751 21.0354 12.9499 21.0354 12.4688 21.4438C11.9876 21.8521 11.2624 21.8521 10.7812 21.4438C10.3001 21.0354 9.57494 21.0354 9.09375 21.4438C8.76682 21.7212 8.25 21.4996 8.25 21.0821V8.91794C8.25 8.50037 8.76682 8.27882 9.09375 8.55624C9.57494 8.96455 10.3001 8.96455 10.7812 8.55624C11.2624 8.14792 11.9876 8.14792 12.4688 8.55624C12.9499 8.96455 13.6751 8.96455 14.1562 8.55624C14.6374 8.14792 15.3626 8.14792 15.8438 8.55624C16.3249 8.96455 17.0501 8.96455 17.5312 8.55624C18.0124 8.14792 18.7376 8.14792 19.2188 8.55624C19.6999 8.96455 20.4251 8.96455 20.9062 8.55624C21.2332 8.27882 21.75 8.50037 21.75 8.91794V21.0821C21.75 21.4996 21.2332 21.7212 20.9062 21.4438ZM11.0625 15C11.0625 14.6893 11.3143 14.4375 11.625 14.4375H18.375C18.6857 14.4375 18.9375 14.6893 18.9375 15C18.9375 15.3107 18.6857 15.5625 18.375 15.5625H11.625C11.3143 15.5625 11.0625 15.3107 11.0625 15ZM11.625 11.8125C11.3143 11.8125 11.0625 12.0643 11.0625 12.375C11.0625 12.6857 11.3143 12.9375 11.625 12.9375H18.375C18.6857 12.9375 18.9375 12.6857 18.9375 12.375C18.9375 12.0643 18.6857 11.8125 18.375 11.8125H11.625ZM11.0625 17.625C11.0625 17.3143 11.3143 17.0625 11.625 17.0625H18.375C18.6857 17.0625 18.9375 17.3143 18.9375 17.625C18.9375 17.9357 18.6857 18.1875 18.375 18.1875H11.625C11.3143 18.1875 11.0625 17.9357 11.0625 17.625Z",
    fill: "#1B4597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalExpense);
export default __webpack_public_path__ + "static/media/TotalExpense.4048045fa8c214c362f6b1b2f80a93ed.svg";
export { ForwardRef as ReactComponent };